import {Button, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import ResultsCC1 from './ResultsCC1';
import ResultsCC2 from './ResultsCC2';

const {Paragraph} = Typography;
const {Content} = Layout;

const ResultsCCTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Structures at different<br/>multiplicities and configurations</Button>, key: 'uno', children: <ResultsCC1/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Molecular properties calculations</Button>, key: 'dos', children: <ResultsCC2/>},
  ];
  return (
    <Layout style={{margin: '5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Results and discussion</Paragraph>
      </Content>
      <Content style={{padding: '2vh', background: 'transparent', marginTop: '-6vh'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default ResultsCCTabs;
